import { call, put, delay, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actions, { Types } from '~/store/ducks/invoices';
import snackbar from '../ducks/snackbar';
import api from '~/services/api';

function* loadAllInvoices({ partner }) {
  try {
    const { data } = yield call(api.get, `/v1/partners/${partner}/invoices`);
    if (data) {
      yield put(actions.loadAllInvoicesSuccess(data));
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadInvoiceTransaction({ partner, invoice }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/invoices/${invoice}`
    );

    if (data) {
      if (data.paid_at) {
        const [paid_at] = data.paid_at.match(
          /[0-9]{2}[-|/]{1}[0-9]{2}[-|/]{1}[0-9]{4}/
        );

        const [day, month, year] = paid_at.split('/');
        const start_date = `${year}-${month}-${day}`;
        const end_date = `${year}-${month}-${day}`;

        const params = {
          'order.id': data.order_id,
          start_date,
          end_date
        };

        const {
          data: { entries }
        } = yield call(api.get, `/v1/partners/${partner}/transactions`, {
          params
        });

        console.log(entries);

        if (entries) {
          const transactionsData = entries;

          if (transactionsData.length > 0) {
            const transaction = {
              ...transactionsData[0],
              url: `/transactions/${transactionsData[0].id}`
            };

            yield put(actions.loadInvoiceTransactionSuccess(transaction));
          }
        }
      }

      yield put(actions.loadInvoiceSuccess(data));
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadInvoice({ partner, invoice }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/invoices/${invoice}`
    );

    if (data) {
      yield put(actions.loadInvoiceSuccess(data));
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* addInvoice({ partner, data }) {
  try {
    const res = yield call(api.post, `/v1/partners/${partner}/invoices`, data);
    yield put(actions.addInvoiceSuccess());

    if (res.data) {
      yield put(
        snackbar.showSnackbar({
          color: 'success',
          icon: 'check',
          text: 'invoice.add.success'
        })
      );

      yield put(push(`/invoices/details/${res.data.id}`));

      yield delay(5000);
      yield put(snackbar.hideSnackbar());
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* cancelInvoice({ partner, invoice }) {
  try {
    const { data } = yield call(
      api.put,
      `/v1/partners/${partner}/invoices/${invoice}/void`
    );

    if (data) {
      yield put(actions.loadInvoiceSuccess(data));
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* exportInvoices({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/invoices/export`,
      params
    );

    if (data) {
      yield put(actions.exportInvoicesSuccess());

      const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement('a');

      link.href = window.URL.createObjectURL(blob);
      link.download = `invoices-${new Date().getTime()}.csv`;
      link.click();
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_ALL_INVOICES, loadAllInvoices),
  takeLatest(Types.LOAD_INVOICE, loadInvoice),
  takeLatest(Types.LOAD_INVOICE_TRANSACTION, loadInvoiceTransaction),
  takeLatest(Types.ADD_INVOICE, addInvoice),
  takeLatest(Types.CANCEL_INVOICE, cancelInvoice),
  takeLatest(Types.EXPORT_INVOICES, exportInvoices)
];

export default sagas;
